import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('cookies-bar', Component);

    const active = ref(true);

    const cookiesBar = { active };

    app.config.globalProperties.$cookiesBar = cookiesBar;
    app.provide('$cookiesBar', cookiesBar);
  }
}